import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useWatch } from 'react-hook-form'

import { FormValues } from '../../../lib/cart/types'
import AddressFormCheckout from '../shared/AddressFormCheckout'
import ReadOnlyAddressForm from '../shared/ReadOnlyAddressForm'
import useStyles from './styles/billingDetails'

export interface BillingDetailsProps {
  billingSameAsShipping: boolean
  defaultAddressValues: FormValues.Address
  setBillingSameAsShipping: (val: boolean) => void
}

const BillingDetails: React.FC<BillingDetailsProps> = ({
  billingSameAsShipping,
  defaultAddressValues,
  setBillingSameAsShipping,
}) => {
  const classes = useStyles()
  const selectedCreditCardId = useWatch<FormValues.SavedCreditCard>({
    name: 'selectedSavedCreditCardId',
  })

  if (selectedCreditCardId) {
    return null
  }

  return (
    <Grid container item xs={12} className={classes.root} spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">BILLING DETAILS</Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          classes={{ root: classes.addressToggle }}
          control={
            <Checkbox
              checked={billingSameAsShipping}
              onChange={(e) => setBillingSameAsShipping(e.target.checked)}
              data-cy="use-billing-as-shipping-address"
            />
          }
          label="Billing address is the same as shipping address"
        />
      </Grid>

      <Grid container item xs={12}>
        {billingSameAsShipping ? (
          <ReadOnlyAddressForm
            clickToEditText="Click to edit billing address"
            defaultValues={defaultAddressValues}
            onClickToEdit={() => setBillingSameAsShipping(false)}
          />
        ) : (
          <AddressFormCheckout defaultValues={defaultAddressValues} />
        )}
      </Grid>
    </Grid>
  )
}

export default BillingDetails
